// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General brand visual beside an auth form (login / register). Self-contained
   (av-*), brand purple (#5e1bff family), DM Sans. Fills its parent. Copied 1:1
   from WixAuthVisual.css but generalized (no Wix-specific content). */
.av {
  position: relative;
  height: 100%;
  min-height: 100%;
  overflow: hidden;
  background: linear-gradient(158deg, #6a28ff 0%, #4c18cc 52%, #2c0a63 100%);
  color: #fff;
  font-family: 'DM Sans', system-ui, sans-serif;
}

/* faint diagonal grid that fades toward the bottom — premium depth, no banding */
.av-grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.06) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.06) 1px, transparent 1px);
  background-size: 34px 34px;
  mask-image: radial-gradient(125% 80% at 72% 0%, #000 35%, transparent 78%);
  pointer-events: none;
}
.av-glow {
  position: absolute;
  inset: 0;
  background: radial-gradient(58% 42% at 80% 8%, rgba(255, 255, 255, 0.17), transparent 62%);
  pointer-events: none;
}

.av-inner {
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 44px 40px;
  box-sizing: border-box;
}
/* Top block (header + carousel) pinned to the top so the header never shifts
   when a carousel card's description wraps; the marquee is pinned to the bottom. */
.av-top {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.av-eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.72);
  margin-bottom: 14px;
}
.av-title {
  font-size: 1.72rem;
  font-weight: 700;
  line-height: 1.16;
  letter-spacing: -0.015em;
  margin: 0 0 10px;
}
.av-sub {
  font-size: 0.95rem;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.82);
  margin: 0 0 24px;
  max-width: 93%;
}

/* ── Carousel: ONE capability at a time, auto-advancing ── */
.av-carousel { margin-top: 2px; }
.av-action {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 16px;
  padding: 17px 18px;
  backdrop-filter: blur(10px);
  box-shadow: 0 14px 32px rgba(18, 4, 52, 0.3);
  min-height: 116px;
  display: flex;
  flex-direction: column;
  animation: av-action-in 0.5s cubic-bezier(0.16, 1, 0.3, 1) both;
}
@keyframes av-action-in {
  from { opacity: 0; transform: translateY(10px) scale(0.985); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}
.av-action-head {
  display: flex;
  align-items: center;
  gap: 11px;
  margin-bottom: 12px;
}
/* White tile so general brand logos (Stripe, Notion, ...) render cleanly,
   centered and contained rather than cropped. */
.av-action-logo {
  flex: 0 0 auto;
  width: 42px;
  height: 42px;
  border-radius: 11px;
  overflow: hidden;
  background: #fff;
  display: grid;
  place-items: center;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.18);
}
.av-action-logo img { width: 26px; height: 26px; object-fit: contain; display: block; }
/* Logos that ship as a full square with their own brand background (n8n): let
   them fill the rounded tile instead of floating shrunken on white. */
.av-action-logo.av-bleed { background: transparent; }
.av-action-logo.av-bleed img { width: 100%; height: 100%; object-fit: cover; }
.av-action-app {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.66);
}
.av-action-dot {
  margin-left: auto;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #34d399;
  box-shadow: 0 0 0 4px rgba(52, 211, 153, 0.2);
}
.av-action-title { font-size: 1.16rem; font-weight: 700; letter-spacing: -0.01em; }
.av-action-desc {
  font-size: 0.84rem;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.78);
  margin-top: 4px;
}

/* prev / dots / next */
.av-controls {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 14px;
}
.av-arrow {
  flex: 0 0 auto;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.22);
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  cursor: pointer;
  display: grid;
  place-items: center;
  font-size: 0.72rem;
  transition: background 0.2s, transform 0.2s;
}
.av-arrow:hover { background: rgba(255, 255, 255, 0.18); transform: translateY(-1px); }
.av-dots {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0 auto;
}
.av-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  border: none;
  padding: 0;
  background: rgba(255, 255, 255, 0.3);
  cursor: pointer;
  transition: background 0.2s, width 0.2s;
}
.av-dot.av-on {
  width: 18px;
  border-radius: 3px;
  background: #fff;
}

/* ── Marquee: everything the agent connects to (pinned to the bottom) ── */
.av-more { flex: 0 0 auto; margin-top: 22px; }
.av-more-label {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.6);
}
.av-marquee {
  /* \`overflow: hidden\` is what keeps the strip inside the panel, but it also
     clips the hover lift + shadow of a tile. Pad the clip box vertically and
     pull the extra height back off with a negative margin, so the tiles sit
     exactly where they did and still have room to rise. */
  margin-top: 0;
  padding: 12px 0;
  margin-bottom: -12px;
  overflow: hidden;
  mask-image: linear-gradient(90deg, transparent, #000 10%, #000 90%, transparent);
}
.av-marquee-track {
  display: flex;
  width: max-content;
  /* 16 logos; keep the duration proportional to the tool count so the scroll
     speed stays the same when the list grows (~1.4s per logo) */
  animation: av-marquee 22s linear infinite;
}
.av-marquee:hover .av-marquee-track { animation-play-state: paused; }
/* Each logo is wrapped in InfoTooltip — its .info-tooltip-wrapper is the flex item.
   Put the loop margin on the wrapper (not the tile) so the duplicated track still
   translates -50% seamlessly. */
.av-marquee-track .info-tooltip-wrapper {
  flex: 0 0 auto;
  margin: 0 9px 0 0;
}
.av-more-logo {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  background: #fff;
  display: grid;
  place-items: center;
  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.14);
  cursor: default;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}
.av-more-logo:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 14px rgba(0, 0, 0, 0.22);
}
.av-more-logo img { width: 21px; height: 21px; object-fit: contain; }
.av-more-logo.av-bleed { background: transparent; overflow: hidden; }
.av-more-logo.av-bleed img { width: 100%; height: 100%; object-fit: cover; }
@keyframes av-marquee {
  from { transform: translateX(0); }
  to   { transform: translateX(-50%); }
}

@media (prefers-reduced-motion: reduce) {
  .av-action { animation: none; }
  .av-marquee-track { animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/AuthVisual.css"],"names":[],"mappings":"AAAA;;sEAEsE;AACtE;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,0EAA0E;EAC1E,WAAW;EACX,6CAA6C;AAC/C;;AAEA,iFAAiF;AACjF;EACE,kBAAkB;EAClB,QAAQ;EACR;;0EAEwE;EACxE,0BAA0B;EAE1B,0EAA0E;EAC1E,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,0FAA0F;EAC1F,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;mFACmF;AACnF;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;AAChB;;AAEA,6DAA6D;AAC7D,eAAe,eAAe,EAAE;AAChC;EACE,oCAAoC;EACpC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAElB,2BAA2B;EAC3B,4CAA4C;EAC5C,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,+DAA+D;AACjE;AACA;EACE,OAAO,UAAU,EAAE,wCAAwC,EAAE;EAC7D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;gDACgD;AAChD;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;AACA,sBAAsB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,cAAc,EAAE;AACtF;sEACsE;AACtE,2BAA2B,uBAAuB,EAAE;AACpD,+BAA+B,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;AAC7E;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;AAC/C;AACA,mBAAmB,kBAAkB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AAClF;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;AAC7C;AACA,kBAAkB,qCAAqC,EAAE,2BAA2B,EAAE;AACtF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,oCAAoC;EACpC,eAAe;EACf,uCAAuC;AACzC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,2EAA2E;AAC3E,WAAW,cAAc,EAAE,gBAAgB,EAAE;AAC7C;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE;;;0DAGwD;EACxD,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAEhB,gFAAgF;AAClF;AACA;EACE,aAAa;EACb,kBAAkB;EAClB;gEAC8D;EAC9D,yCAAyC;AAC3C;AACA,sCAAsC,4BAA4B,EAAE;AACpE;;gCAEgC;AAChC;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,uDAAuD;AACzD;AACA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;AACA,oBAAoB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AACpE,yBAAyB,uBAAuB,EAAE,gBAAgB,EAAE;AACpE,6BAA6B,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;AAC3E;EACE,OAAO,wBAAwB,EAAE;EACjC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,aAAa,eAAe,EAAE;EAC9B,oBAAoB,eAAe,EAAE;AACvC","sourcesContent":["/* General brand visual beside an auth form (login / register). Self-contained\r\n   (av-*), brand purple (#5e1bff family), DM Sans. Fills its parent. Copied 1:1\r\n   from WixAuthVisual.css but generalized (no Wix-specific content). */\r\n.av {\r\n  position: relative;\r\n  height: 100%;\r\n  min-height: 100%;\r\n  overflow: hidden;\r\n  background: linear-gradient(158deg, #6a28ff 0%, #4c18cc 52%, #2c0a63 100%);\r\n  color: #fff;\r\n  font-family: 'DM Sans', system-ui, sans-serif;\r\n}\r\n\r\n/* faint diagonal grid that fades toward the bottom — premium depth, no banding */\r\n.av-grid {\r\n  position: absolute;\r\n  inset: 0;\r\n  background-image:\r\n    linear-gradient(rgba(255, 255, 255, 0.06) 1px, transparent 1px),\r\n    linear-gradient(90deg, rgba(255, 255, 255, 0.06) 1px, transparent 1px);\r\n  background-size: 34px 34px;\r\n  -webkit-mask-image: radial-gradient(125% 80% at 72% 0%, #000 35%, transparent 78%);\r\n  mask-image: radial-gradient(125% 80% at 72% 0%, #000 35%, transparent 78%);\r\n  pointer-events: none;\r\n}\r\n.av-glow {\r\n  position: absolute;\r\n  inset: 0;\r\n  background: radial-gradient(58% 42% at 80% 8%, rgba(255, 255, 255, 0.17), transparent 62%);\r\n  pointer-events: none;\r\n}\r\n\r\n.av-inner {\r\n  position: relative;\r\n  z-index: 1;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 44px 40px;\r\n  box-sizing: border-box;\r\n}\r\n/* Top block (header + carousel) pinned to the top so the header never shifts\r\n   when a carousel card's description wraps; the marquee is pinned to the bottom. */\r\n.av-top {\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.av-eyebrow {\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.16em;\r\n  text-transform: uppercase;\r\n  color: rgba(255, 255, 255, 0.72);\r\n  margin-bottom: 14px;\r\n}\r\n.av-title {\r\n  font-size: 1.72rem;\r\n  font-weight: 700;\r\n  line-height: 1.16;\r\n  letter-spacing: -0.015em;\r\n  margin: 0 0 10px;\r\n}\r\n.av-sub {\r\n  font-size: 0.95rem;\r\n  line-height: 1.5;\r\n  color: rgba(255, 255, 255, 0.82);\r\n  margin: 0 0 24px;\r\n  max-width: 93%;\r\n}\r\n\r\n/* ── Carousel: ONE capability at a time, auto-advancing ── */\r\n.av-carousel { margin-top: 2px; }\r\n.av-action {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  border: 1px solid rgba(255, 255, 255, 0.16);\r\n  border-radius: 16px;\r\n  padding: 17px 18px;\r\n  -webkit-backdrop-filter: blur(10px);\r\n  backdrop-filter: blur(10px);\r\n  box-shadow: 0 14px 32px rgba(18, 4, 52, 0.3);\r\n  min-height: 116px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  animation: av-action-in 0.5s cubic-bezier(0.16, 1, 0.3, 1) both;\r\n}\r\n@keyframes av-action-in {\r\n  from { opacity: 0; transform: translateY(10px) scale(0.985); }\r\n  to   { opacity: 1; transform: translateY(0) scale(1); }\r\n}\r\n.av-action-head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 11px;\r\n  margin-bottom: 12px;\r\n}\r\n/* White tile so general brand logos (Stripe, Notion, ...) render cleanly,\r\n   centered and contained rather than cropped. */\r\n.av-action-logo {\r\n  flex: 0 0 auto;\r\n  width: 42px;\r\n  height: 42px;\r\n  border-radius: 11px;\r\n  overflow: hidden;\r\n  background: #fff;\r\n  display: grid;\r\n  place-items: center;\r\n  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.18);\r\n}\r\n.av-action-logo img { width: 26px; height: 26px; object-fit: contain; display: block; }\r\n/* Logos that ship as a full square with their own brand background (n8n): let\r\n   them fill the rounded tile instead of floating shrunken on white. */\r\n.av-action-logo.av-bleed { background: transparent; }\r\n.av-action-logo.av-bleed img { width: 100%; height: 100%; object-fit: cover; }\r\n.av-action-app {\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.12em;\r\n  text-transform: uppercase;\r\n  color: rgba(255, 255, 255, 0.66);\r\n}\r\n.av-action-dot {\r\n  margin-left: auto;\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background: #34d399;\r\n  box-shadow: 0 0 0 4px rgba(52, 211, 153, 0.2);\r\n}\r\n.av-action-title { font-size: 1.16rem; font-weight: 700; letter-spacing: -0.01em; }\r\n.av-action-desc {\r\n  font-size: 0.84rem;\r\n  line-height: 1.4;\r\n  color: rgba(255, 255, 255, 0.78);\r\n  margin-top: 4px;\r\n}\r\n\r\n/* prev / dots / next */\r\n.av-controls {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin-top: 14px;\r\n}\r\n.av-arrow {\r\n  flex: 0 0 auto;\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 50%;\r\n  border: 1px solid rgba(255, 255, 255, 0.22);\r\n  background: rgba(255, 255, 255, 0.08);\r\n  color: #fff;\r\n  cursor: pointer;\r\n  display: grid;\r\n  place-items: center;\r\n  font-size: 0.72rem;\r\n  transition: background 0.2s, transform 0.2s;\r\n}\r\n.av-arrow:hover { background: rgba(255, 255, 255, 0.18); transform: translateY(-1px); }\r\n.av-dots {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  margin: 0 auto;\r\n}\r\n.av-dot {\r\n  width: 6px;\r\n  height: 6px;\r\n  border-radius: 50%;\r\n  border: none;\r\n  padding: 0;\r\n  background: rgba(255, 255, 255, 0.3);\r\n  cursor: pointer;\r\n  transition: background 0.2s, width 0.2s;\r\n}\r\n.av-dot.av-on {\r\n  width: 18px;\r\n  border-radius: 3px;\r\n  background: #fff;\r\n}\r\n\r\n/* ── Marquee: everything the agent connects to (pinned to the bottom) ── */\r\n.av-more { flex: 0 0 auto; margin-top: 22px; }\r\n.av-more-label {\r\n  font-size: 10.5px;\r\n  font-weight: 600;\r\n  letter-spacing: 0.1em;\r\n  text-transform: uppercase;\r\n  color: rgba(255, 255, 255, 0.6);\r\n}\r\n.av-marquee {\r\n  /* `overflow: hidden` is what keeps the strip inside the panel, but it also\r\n     clips the hover lift + shadow of a tile. Pad the clip box vertically and\r\n     pull the extra height back off with a negative margin, so the tiles sit\r\n     exactly where they did and still have room to rise. */\r\n  margin-top: 0;\r\n  padding: 12px 0;\r\n  margin-bottom: -12px;\r\n  overflow: hidden;\r\n  -webkit-mask-image: linear-gradient(90deg, transparent, #000 10%, #000 90%, transparent);\r\n  mask-image: linear-gradient(90deg, transparent, #000 10%, #000 90%, transparent);\r\n}\r\n.av-marquee-track {\r\n  display: flex;\r\n  width: max-content;\r\n  /* 16 logos; keep the duration proportional to the tool count so the scroll\r\n     speed stays the same when the list grows (~1.4s per logo) */\r\n  animation: av-marquee 22s linear infinite;\r\n}\r\n.av-marquee:hover .av-marquee-track { animation-play-state: paused; }\r\n/* Each logo is wrapped in InfoTooltip — its .info-tooltip-wrapper is the flex item.\r\n   Put the loop margin on the wrapper (not the tile) so the duplicated track still\r\n   translates -50% seamlessly. */\r\n.av-marquee-track .info-tooltip-wrapper {\r\n  flex: 0 0 auto;\r\n  margin: 0 9px 0 0;\r\n}\r\n.av-more-logo {\r\n  width: 34px;\r\n  height: 34px;\r\n  border-radius: 9px;\r\n  background: #fff;\r\n  display: grid;\r\n  place-items: center;\r\n  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.14);\r\n  cursor: default;\r\n  transition: transform 0.18s ease, box-shadow 0.18s ease;\r\n}\r\n.av-more-logo:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 5px 14px rgba(0, 0, 0, 0.22);\r\n}\r\n.av-more-logo img { width: 21px; height: 21px; object-fit: contain; }\r\n.av-more-logo.av-bleed { background: transparent; overflow: hidden; }\r\n.av-more-logo.av-bleed img { width: 100%; height: 100%; object-fit: cover; }\r\n@keyframes av-marquee {\r\n  from { transform: translateX(0); }\r\n  to   { transform: translateX(-50%); }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .av-action { animation: none; }\r\n  .av-marquee-track { animation: none; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
